// WP-1.20 (S-46 About): deployment identity + the persisted structured error log (WP-0.5).
import { useErrors, useMeta } from '../../lib/system';

export function SettingsAbout(): React.JSX.Element {
  const { data: meta } = useMeta();
  const { data: errors } = useErrors();

  return (
    <div className="space-y-6">
      <section className="rounded-[var(--radius-card)] border border-border bg-surface p-4">
        <h2 className="mb-3 text-sm font-medium text-ink">About</h2>
        <dl className="grid grid-cols-2 gap-1 text-sm">
          <dt className="text-muted">App</dt>
          <dd className="text-ink">{meta?.app ?? '—'}</dd>
          <dt className="text-muted">Engine API version</dt>
          <dd className="text-ink">{meta?.engineApiVersion ?? '—'}</dd>
          <dt className="text-muted">Events recorded</dt>
          <dd className="text-ink">{meta?.eventCount ?? '—'}</dd>
        </dl>
      </section>

      <section className="rounded-[var(--radius-card)] border border-border bg-surface p-4">
        <h2 className="mb-3 text-sm font-medium text-ink">Error log</h2>
        {(errors ?? []).length === 0 ? (
          <p className="text-sm text-muted">No errors logged. 🎉</p>
        ) : (
          <ul className="space-y-2">
            {(errors ?? []).map((e) => (
              <li key={e.id} className="border-b border-border pb-2 text-xs last:border-0">
                <span className="text-muted">{e.at.slice(0, 16).replace('T', ' ')}</span>
                {e.method !== null && e.url !== null && (
                  <span className="ml-2 text-muted">
                    {e.method} {e.url}
                  </span>
                )}
                <p className="text-ink">{e.message}</p>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
